var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8447 24.5045C26.8447 29.7535 22.6261 34.0086 17.4225 34.0086C12.2189 34.0086 8 29.7525 8 24.5045C8 19.2564 12.2186 15 17.4225 15C22.6265 15 26.8447 19.2555 26.8447 24.5045Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1811 24.5048C37.1811 29.4457 35.0718 33.4526 32.4698 33.4526C29.8678 33.4526 27.7585 29.4457 27.7585 24.5048C27.7585 19.564 29.8675 15.5571 32.4695 15.5571C35.0715 15.5571 37.1808 19.5628 37.1808 24.5048",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4091 24.5045C41.4091 28.9303 40.6673 32.5203 39.7521 32.5203C38.8369 32.5203 38.0955 28.9312 38.0955 24.5045C38.0955 20.0778 38.8372 16.4888 39.7521 16.4888C40.667 16.4888 41.4091 20.0775 41.4091 24.5045Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.346ee9e7946423db2b95bbe279655e5c.svg";
export { ForwardRef as ReactComponent };